module.exports = __webpack_public_path__ + "static/media/ENGLong2w427@1x.af06b64b.jpg";